export default __webpack_public_path__ + "static/step_10-d787a562e0c2561ef585da753789b99f.png";